import React, { useState } from 'react'
import { InputField } from '../../components/Input'
import AuthLayout from '../../layouts/AuthLayout'
import { Link, useNavigate } from 'react-router-dom';
import signinRequest from '../../requests/signin';
import { signIn,setToken } from '../../adapters/authentication';
import useAuthStore from  '../../store/auth';
import { ErrorStatus } from '../../components/FormStatus';
import { useLocation } from 'react-router-dom';

export default function Signin() {

  const setAuth = useAuthStore((state) => state.setAuth);

  const location = useLocation();
  const { from, redirectFrom } = location.state || {};

  const [errors, setErrors] = useState([]);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');

 
  const login = async () => {
    await signinRequest.validate({ email, password}).then(() => {
      signIn({ email, password}).then((res) => {
        if(res.data.token){
          setToken(res.data.token);
          const user = res.data.user;
          setAuth({ ...res.data, authenticated: true});        
          setEmail(''); 
          setPassword('');
          const nexPath = redirectFrom;
          if(user.role === 0){
            if(user.accountType === 1){
              navigate(nexPath ?? '/account/dashboard', { refresh: true, replace: true })
            }else{
              navigate(nexPath ?? '/neutral/dashboard', { replace: true, refresh: true})
            }
          }else{
            navigate(nexPath ?? '/admin/dashboard', { replace: true, refresh: true })
          }

        }
      }).catch((err) => {
        setErrors(['Invalid email or password'])
      })
    }).catch((err) => {
      setErrors(err.errors);
    })
  }


  return (
    <AuthLayout title="Sign In">

      <ErrorStatus errors={errors} />
      
      <form onSubmit={(e) => {
        e.preventDefault();
        login();
      }}>
        <InputField type="email" placeholder="Email" onChange={(e)=> {
          e.preventDefault();
          setErrors([]);
          setEmail(e.target.value)
        }} defaultValue="" name="email" id="email" label="Email" />
        <InputField type="password" placeholder="Password" showStrength={false} onChange={(e)=> {
          e.preventDefault();
          setErrors([]);
          setPassword(e.target.value);
        }} defaultValue="" name="password" id="password" label="Password" />
        <div className="flex justify-between items-center px-3 text-sm font-semibold">
          <label className="inline-flex items-center mt-3 text-xs font-fira">
            <input type="checkbox" className="h-4 w-4 rounded-xl" /><span className="ml-2 text-gray-700">Remember me</span>
          </label>
          <Link to="/forgot-password" className="text-blue-900 text-xs underline hover:text-blue-600">Forgot Password</Link>
        </div>
        <div className="mt-3 px-3">
          <button className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg " type="submit">
            Sign in
          </button>
          <div className="mt-3 flex items-center justify-center w-full relative">
            <span className="absolute px-1 py-0 text-center mx-auto text-xs font-semibold"> Or </span>
          </div>
          <Link to="/auth/sign-up" className="py-3 font-fira mt-1 hover:text-blue-900  text-sm font-semibold w-full text-center flex justify-center items-center text-blue-800 rounded-lg " type="submit">
            Sign up
          </Link>
        </div>
      </form>
    </AuthLayout>
  )
}
